// components/search/LocationFallback.jsx
import React from 'react';
import GeoLocationResolver from './GeoLocationResolver';

export default function LocationFallback({ userCoords, setUserCoords }) {
  // Only render the fallback if location hasn't been resolved yet
  if (userCoords) return null;

  return (
    <GeoLocationResolver setUserCoords={setUserCoords} />
  );
}